export default {
  title: 'Dados gerais',
  document: 'NIE/CIF',
  reason: 'Razão Social',
  email: 'Email',
  address: 'Endereço',
  postalCode: 'Código Postal',
  town: 'Cidade',
  city: 'Província',
  country: 'País',
  inscription: 'Inscrição Reg. Comercial',
  accountAssignedId: 'Código Conta Contábil',
  irpf: {
    retention: 'Retenção IRPF',
    notSupported: 'Não suporta IRPF'
  },
  greenPoint: {
    label: 'Ponto Verde',
    notSupported: 'Não suportado',
    included: 'Incluído no valor',
    brokenDown: 'Desagregado por linha'
  },
  subjectTo: 'Sujeito ao Regime Especial de Critério de Caixa',
  help: 'Empresa sujeita ao Regime Especial de Critério de Caixa, conforme o Art. 23 da Lei 14/2013',
  ticketbaiRequired: 'Notificar ao TicketBAI',
  headingBizkaia: 'Epígrafe',
  headingListBizkaia: 'Baixar lista de epígrafes',
  ticketbaiRequiredHelp: 'Norma Foral 13/2021, de 21 de abril (Álava). Norma Foral 3/2020, de 6 de novembro (Guipúzcoa), Norma Foral 8/2023, de 22 de novembro (Biscaia).',
  siiRequired: 'Notificar o SII (LRFE)',
  siiRequiredHelp: `<br>O período de liquidação do registo no SII corresponderá ao ano e ao mês da data de acumulação da fatura. <br>A data de emissão e de registo no SII é a data de emissão da fatura.`,
  modal: {
    text: 'Os dados foram atualizados com sucesso.'
  },
  terms: 'Termos e condições do contrato',
  version: {
    title: 'Sistema Efactura',
    front: 'Versão Front: ',
    core: 'Versão Core: ',
    back: 'Versão API: '
  },
  verifactu: {
    title: 'VERI*FACTU',
    yesOption: 'Sim',
    noOption: 'Não',
    exemptOption: 'Isento',
    exemptReasonPlaceholder: 'Motivo da isenção',
    modal: {
      info: 'Uma vez ativada esta opção, os ficheiros serão enviados imediatamente após a emissão de cada fatura.\n\nNão poderá alterar esta opção até 1 de janeiro do ano seguinte, conforme indicado pela lei.\n\nSe a fatura original já foi enviada de outro ERP, é possível que as comunicações com a AEAT sejam duplicadas. Certifique-se disso antes de enviar a fatura.',
      link: 'Mais informação'
    },
    lockedTooltip: 'Não poderá alterar esta opção até 1 de janeiro do ano seguinte',
    rdTooltip: 'Real Decreto 254/2025, de 1 de abril, por el que se modifica el Real Decreto 1007/2023, de 5 de diciembre'
  },
  eReporting: 'E-REPORTING',
  eReportingError: 'Só pode selecionar uma opção de E-REPORTING'
}